import { Alert, Button, Modal } from "react-bootstrap";

export interface DeferredRequestCompeteViewProps {
  downloadUrl: string;
}

const DeferredRequestCompeteView = ({
  downloadUrl,
}: DeferredRequestCompeteViewProps) => {
  const download = () => {
    window.location.href = downloadUrl;
  };

  return (
    <>
      <Modal.Body>
        <Alert variant="success">Your data is ready!</Alert>
        <p>Download it below</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={download}>
          Download Data
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DeferredRequestCompeteView;
